import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=d9d36294"
import script from "./InventoryItem.vue?vue&type=script&lang=js"
export * from "./InventoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports